import { Button } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import firebase from "firebase";
import { useEffect, useState } from "react";
import MyDialog from "../../custom-components/dialog";
import MyTable from "../../custom-components/table";
import { db } from "../../firebase";


export default function IntermediateCoachingPage(props) {
    const { session, getSessions } = props
    const [table, settable] = useState([])
    const [hasSignedUp, sethasSignedUp] = useState(false)
    const [dialogOpen, setdialogOpen] = useState(false)
    const [withdDialogOpen, setwithdDialogOpen] = useState(false)

    const interCoachTableDBRef = db.collection('intermediate-coaching').doc(session.id).collection('attendents')
    const appusersDBRef = db.collection('appusers').doc(firebase.auth().currentUser.uid)
    const columns = ['name']

    async function getTable() {
        interCoachTableDBRef
            .get()
            .then((querySnapShot) => {
                let newTable = []
                querySnapShot.forEach((doc) => {
                    const ply = doc.data()
                    newTable.push({
                        uid: ply.uid,
                        name: ply.name,
                        email: ply.email,
                    })
                })

                settable(newTable)
            }).catch((e) => {
                console.log(e)
            })
    }

    function handleSignup() {
        setdialogOpen(true)
    }

    async function confirmSignup() {
        await getTable() // update table, see the capacity

        var myProf = {}
        await appusersDBRef
            .get()
            .then((doc) => {
                myProf = doc.data()
            })
            .catch((e) => {
                console.error(e)
            })

        const uid = firebase.auth().currentUser.uid
        const name = myProf.displayName
        const email = firebase.auth().currentUser.email
        const time = new Date().toString()

        await interCoachTableDBRef.doc(uid)
            .set({
                uid,
                name,
                email,
                time,
            })
            .then(() => {
                fetchMyAvailability()
            })
            .catch(() => {
                console.error("Error occurred while trying to sign up for session.")
            })
        setdialogOpen(false)
    }

    function handleWithdraw() {
        setwithdDialogOpen(true)
    }

    async function confirmWidthdraw() {
        const uid = firebase.auth().currentUser.uid
        interCoachTableDBRef.doc(uid)
            .delete()
            .then(() => {
                fetchMyAvailability()
            })
            .catch(() => {
                console.error("Error occurred while trying to withdraw for session.")
            })
        getTable()
        setwithdDialogOpen(false)
    }

    function fetchMyAvailability() {
        interCoachTableDBRef.doc(firebase.auth().currentUser.uid)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    sethasSignedUp(true)
                    console.log("Document data:", doc.data());
                } else {
                    sethasSignedUp(false)
                }
            })
            .catch(() => {
                console.error('error fetching my availability')
            })
    }



    useEffect(() => {
        getTable()
        fetchMyAvailability()
    }, [session, hasSignedUp])

    useEffect(() => {
        // console.log('table', table)
    }, [table])

    const signupInfo = hasSignedUp ? (
        <div>
            <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                <strong>You have signed up for this session!</strong>
            </Alert>
            <Button variant="contained" size='large' color='warning' onClick={handleWithdraw} >Withdraw from this session</Button>
        </div>
    ) : (
        <Button variant="contained" size='large' color='info' onClick={handleSignup} >Sign up for this session</Button>
    )

    return (
        <div>
            <MyDialog open={dialogOpen}
                dialogTitle='Sign Up'
                dialogContent='Are you sure you want to sign up for this Intermediate Coaching Session?'
                onConfirm={confirmSignup}
                closeDialog={() => { setdialogOpen(false) }} ></MyDialog>

            <MyDialog open={withdDialogOpen}
                dialogTitle='Withdraw'
                dialogContent='Are you sure you want to withdraw for this Intermediate Coaching Session?'
                onConfirm={confirmWidthdraw}
                closeDialog={() => { setwithdDialogOpen(false) }} ></MyDialog>
            <h3>{session.sessionName}</h3>
            <p>{table.length < 20 ? signupInfo :
                <div>
                    <Alert severity="warning" >This session is currently full. The capacity of an intermediate coaching session is 20 players.</Alert>
                    {hasSignedUp ?

                        <div>
                            <Alert severity="success">
                                <AlertTitle>Success</AlertTitle>
                                <strong>You have signed up for this session!</strong>
                            </Alert>
                            <Button variant="contained" size='large' color='warning' onClick={handleWithdraw} >Withdraw from this session</Button>
                        </div>
                        :
                        null
                    }
                </div>

            }</p>
            <p>Date: {session.date}</p>
            <p>Time: {session.time}</p>

            <MyTable columns={columns} rows={table}></MyTable>
        </div>
    )
}